import { useEffect, useRef } from 'react';
import { GoogleMap, MarkerF } from '@react-google-maps/api';

function HomeVisitMap({ userLocation, nurses }) {
	const mapRef = useRef(null);

	const onMapLoad = (map) => {
		mapRef.current = map;
	};

	useEffect(() => {
		if (!mapRef.current) return;

		// Collect all coordinates
		const coords = [];
		if (userLocation?.lat && userLocation?.lng) {
			coords.push(userLocation);
		}
		nurses.forEach((n) => {
			if (n.latitude && n.longitude) {
				coords.push({ lat: n.latitude, lng: n.longitude });
			}
		});

		// If we have at least one coordinate, fit them all
		if (coords.length > 0) {
			const bounds = new window.google.maps.LatLngBounds();
			coords.forEach((c) => bounds.extend(c));
			mapRef.current.fitBounds(bounds);
		}
	}, [userLocation, nurses]);

	return (
		<GoogleMap
			onLoad={onMapLoad}
			center={{ lat: 51.505, lng: -0.09 }}
			zoom={10}
			mapContainerStyle={{ width: '100%', height: '400px' }}
		>
			{userLocation && (
				<MarkerF
					icon="https://maps.google.com/mapfiles/ms/icons/blue-dot.png"
					position={{ lat: userLocation.lat, lng: userLocation.lng }}
				/>
			)}

			{/* nurse markers */}
			{nurses.map((nurse) => (
				<MarkerF
					key={nurse.id}
					icon="https://maps.google.com/mapfiles/ms/icons/red-dot.png"
					position={{ lat: nurse.latitude, lng: nurse.longitude }}
				/>
			))}
		</GoogleMap>
	);
}

export default HomeVisitMap;
